import React, {useState} from "react";
import HoverButton from "../../buttons/HoverButton";
import PopUp from "../../base/popup";

export default function ResetConfirmationPopup(props) {


    return (
        <div className="grid-x align-center">
            <div className="cell text-center">
                <h3 className='text-center mar-bot-10'>Confirm to reset test</h3>
                <p className='popup__text'>
                    Are you sure you want to reset this user's test? They will lose any progress and their test result.
                </p>
                <div className="medium-text-center text-right">
                    <HoverButton className="mar-right-10" color={'white'} onClick={props.onCancel}>No</HoverButton>
                    <HoverButton onClick={props.onConfirm}>Yes</HoverButton>
                </div>
            </div>
        </div>
    )

}